import { Checkbox, Dialog, DialogFooter, DialogType, PrimaryButton, Stack } from '@fluentui/react';
import useFeatureFlagContext from '../feature-flag/useFeatureFlagContext';

interface Props {
  hidden?: boolean;
  onClose?: () => void;
}

const FeatureFlagDialog: React.FC<Props> = ({ onClose, hidden }) => {
  const { enableReferrals, setEnableReferrals, healCorp, setHealCorp, enableChangeServiceType, setEnableChangeServiceType } = useFeatureFlagContext();

  return (
    <Dialog dialogContentProps={{ type: DialogType.largeHeader, title: 'Feature Flags' }} hidden={hidden} onDismiss={onClose}>
      <Stack tokens={{ padding: 6, childrenGap: 16 }} style={{ marginBottom: 20 }}>
        <Checkbox label="Referrals" checked={enableReferrals} onChange={(_, value) => setEnableReferrals(value)} />
        <Checkbox label="Sign in with Heal-Corp Okta" checked={healCorp} onChange={(_, value) => setHealCorp(value)} />
        <Checkbox label="Change Service Type of Visit" checked={enableChangeServiceType} onChange={(_, value) => setEnableChangeServiceType(value)} />
      </Stack>
      <DialogFooter>
        <PrimaryButton onClick={onClose} data-tid="btn_featureFlag_done">
          Done
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};

export default FeatureFlagDialog;
